import { C_BUSINESS_TYPE_ID } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import {
  C_CONDICTION_PROPERTY,
  O_CONDICTION_PROPERTY_FOR_NAME
} from "@/src-refactor/modules/shared/model/const/property/condition-status.const";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

const prepareConditionStatusToClient = (res: IPropertyDetailsResponse) => {
  if (
    [
      C_BUSINESS_TYPE_ID.RENT,
      C_BUSINESS_TYPE_ID.RENT_FURNISHED,
      C_BUSINESS_TYPE_ID.WHITE_LINE_RENTAL
    ].includes(res?.businesstype_id) &&
    res?.condition_status == C_CONDICTION_PROPERTY.RESALE.name
  ) {
    return [C_CONDICTION_PROPERTY.USED];
  }

  return res.condition_status
    ? [O_CONDICTION_PROPERTY_FOR_NAME[res?.condition_status]]
    : [];
};

export default prepareConditionStatusToClient;
